class WorldDataElement {
    public latitude:number;
    public longitude:number;
    // 24 of them:
    public hourlyValues:number[];
}
export = WorldDataElement;
